import { network as actions } from '../actions'
import * as R from 'ramda'

// Reducers for
// store/action-methods/network.js
export const reducer = {}

reducer[actions.SET_NETWORK] = ({ state, action }) =>
  !!action.ops.replace
    ? R.mergeRight(state, action.network)
    : R.mergeDeepRight(state, action.network)

reducer[actions.SET_MEMBERS] = ({ state, action: { payload: members } }) => ({
  ...state,
  '@network/members': members
})

reducer[actions.SET_MEMBER_COUNT] = ({
  state,
  action: { payload: memberCount }
}) => ({
  ...state,
  '@network/member-count': memberCount
})

reducer[actions.SET_NETWORK_BOARDS] = ({
  state,
  action: { payload: boards }
}) => ({
  ...state,
  boards
})

reducer[actions.SET_NETWORK_BOARD_COUNT] = ({
  state,
  action: { payload: boardCount }
}) => ({
  ...state,
  '@network/count-boards': boardCount
})

reducer[actions.SET_NETWORK_PENDING_BOARDS] = ({
  state,
  action: { payload: boards }
}) => ({
  ...state,
  '@network/pending-boards': boards
})

reducer[actions.ADD_ACTIVITIES] = ({
  state,
  action: { payload: activities }
}) => {
  const activity = state['@network/activity'] || {}
  return {
    ...state,
    '@network/activity': R.concat(activity || [], activities)
  }
}
